import AssetsComponent from '../../pages/Assets/AssetsComponent';
import MasterData from '../pages/MasterData/MasterData';
import UserProfile from '../pages/Profile/ProfileComponent';
import AdminWorkReportsComponent from '../pages/WorkReports/AdminWorkReportsComponent';
import Manage from '../pages/Manage/ManageAdminComponent';
import AdminEmployeeOnboardingComponent from '../pages/AdminEmployeeOnboarding/AdminEmployeeOnboardingComponent';
import EmployeePrivilegesTabComponent from '../pages/EmployeePrivileges/EmployeePrivilegesTabComponent';
import QuarterlyCasualLeaveAllocationComponent from '../pages/QuarterlyCasualLeave/QuarterlyCasualLeaveAllocationComponent';
import AdminEmployeeOffboardingComponent from '../pages/AdminEmployeeOffboarding/AdminEmployeeOffboardingComponent';
import BulkUploadComponent from '../../hr/pages/BulkUpload/BulkUploadComponent';
import EmployeeMasterCsvComponent from '../../hr/pages/EmployeeMasterCsv/EmployeeMasterCsvComponent';
import RegisterAdminComponent from '../pages/RegisterAdmin/RegisterAdminComponent';

export const AdminRoutes = [
  {
    key: 'bulkUpload',
    title: 'Bulk Upload',
    path: '/admin-bulk-upload',
    enabled: true,
    component: BulkUploadComponent,
  },
  {
    key: 'employeeMasterCsv',
    title: 'Employee CSV',
    path: '/admin-employee-csv',
    enabled: true,
    component: EmployeeMasterCsvComponent,
  },
  {
    key: 'projects',
    title: 'Projects',
    path: '/admin-projects',
    enabled: true,
    component: Manage,
  },
  {
    key: 'masterData',
    title: 'Master Data',
    path: '/admin-master-data',
    enabled: true,
    component: MasterData,
  },
  {
    key: 'users',
    title: 'Users',
    path: '/admin-users',
    enabled: true,
    component: UserProfile,
  },
  {
    key: 'work-reports',
    title: 'Reports',
    path: '/admin-work-reports',
    enabled: true,
    component: AdminWorkReportsComponent,
  },
  {
    key: 'EmployeeOnboarding',
    title: 'Employee Onboarding',
    path: '/admin-employee-onboarding',
    enabled: true,
    component: AdminEmployeeOnboardingComponent,
  },
  {
    key: 'EmployeeOffboarding',
    title: 'Employee Offboarding',
    path: '/admin-employee-offboarding',
    enabled: true,
    component: AdminEmployeeOffboardingComponent,
  },
  {
    key: 'Assets',
    title: 'Assets',
    path: '/admin-assets',
    enabled: true,
    component: AssetsComponent,
  },
  {
    key: 'Employee Privileges',
    title: 'Employee Privileges',
    path: '/admin-employee-privileges',
    enabled: true,
    component: EmployeePrivilegesTabComponent,
  },
  {
    key: 'Quarterly Casual Leave',
    title: 'Quarterly Casual Leave',
    path: '/admin-quarterly-casual-leave',
    enabled: true,
    component: QuarterlyCasualLeaveAllocationComponent,
  },
  {
    key: 'registerAdmin',
    title: 'Register Admin',
    path: '/admin-register',
    enabled: true,
    component: RegisterAdminComponent,
  },
  // {
  //   key: "users",
  //   title: "Users",
  //   path: "/admin-users",
  //   enabled: true,
  //   component: UserProfile
  // },
  // {
  //   key: "Assets",
  //   title: "Assets",
  //   path: "/admin-assets",
  //   enabled: true,
  //   component: AssetsComponent,
  // },
];
